<template>
    <ul>
        <template v-for="category in categories">
            <li
                @click="selectCategory(category.id)"
                :class="getCategoryCss(category.id)"
                v-if="category.has_material"
            >
                <div class="">
                    {{ category.title }}
                </div>
                <div
                    class="w-16 flex-none"
                    title="Average score (Last 100 questions)"
                >
                    <student-score-box
                        :percent-average="category.avg"
                        :show-average="category.q_total > 0"
                    ></student-score-box>
                </div>
            </li>
        </template>
    </ul>
</template>
<script>
import StudentScoreBox from "@/Components/StudentScoreBox.vue";

export default {
    name: "StudentDesktopCategorySelector",
    emits: ["category-selected"],
    components: { StudentScoreBox },
    props: {
        categories: {},
        initSelectedCategory: {},
    },
    data() {
        return {
            selectedCategory: this.initSelectedCategory,
        };
    },
    methods: {
        getCategoryCss(categoryId) {
            let css =
                "p-2 justify-between items-center flex gap-4 font-medium hover:bg-gray-100 hover:cursor-pointer text-gray-625 rounded border border-l-[5px] border-transparent";

            if (this.selectedCategory.id === categoryId) {
                css += " " + "bg-gray-325 border-l-primary-525";
            }

            return css;
        },
        selectCategory(categoryId) {
            this.$emit("category-selected", categoryId);
        },
    },
};
</script>
